module.exports = __webpack_public_path__ + "25091a5a9cb2da4ff2f59bebe3f2fed5.svg";